const runtime = (window as any).__RUNTIME_CONFIG__ || {};

const trimUrl = (value?: string) => (typeof value === "string" ? value.trim() : "");

/** MobileService local "http" profile — see mobile-service/MobileService/Properties/launchSettings.json */
const LOCAL_MOBILE_SERVICE_URL = "http://localhost:44352";

/**
 * IB v2: single mobile-service base URL for all JWT-authenticated APIs.
 * Prefer REACT_APP_API_URL; falls back to STABLES url, then local MobileService in development.
 */
export const API_URL =
  trimUrl(runtime.API_URL) ||
  trimUrl(process.env.REACT_APP_API_URL) ||
  trimUrl(runtime.STABLES_API_URL) ||
  trimUrl(process.env.REACT_APP_STABLES_API_URL) ||
  (process.env.NODE_ENV === "development" ? LOCAL_MOBILE_SERVICE_URL : "");

/**
 * FIDO/WebAuthn backend — mobile-service /v1/oauth/webauthn/*.
 * Falls back to main API_URL (mobile) when unset.
 */
export const FIDO_API_URL =
  trimUrl(runtime.FIDO_API_URL) || trimUrl(process.env.REACT_APP_FIDO_API_URL) || API_URL;

/**
 * Stables API (mobile-service /v1/stables/*) — same host as API_URL for IB v2.
 * Explicit REACT_APP_STABLES_API_URL overrides; otherwise aliases API_URL.
 */
export const STABLES_API_URL = (() => {
  const runtimeUrl = trimUrl(runtime.STABLES_API_URL);
  if (runtimeUrl) return runtimeUrl;

  const envUrl = trimUrl(process.env.REACT_APP_STABLES_API_URL);
  if (envUrl) return envUrl;

  if (API_URL) return API_URL;

  if (process.env.NODE_ENV === "development") {
    return LOCAL_MOBILE_SERVICE_URL;
  }

  return "";
})();

/** Empty string uses same origin (CRA dev proxy → localhost:44397). */
export const FIAT_API_URL =
  runtime.FIAT_API_URL || process.env.REACT_APP_FIAT_API_URL || "";

export const FIAT_API_KEY =
  runtime.FIAT_API_KEY || process.env.REACT_APP_FIAT_API_KEY || "";

export const FIAT_TENANT_KEY =
  runtime.FIAT_TENANT_KEY || process.env.REACT_APP_FIAT_TENANT_KEY || "";

/**
 * @deprecated Unused for /baas home — programs/instances now use MobileService
 * `GET /v1/ib/baas/programs` via API_URL. Kept for optional legacy Console.Api tooling.
 * Local Console.Api "http" profile: http://localhost:5190
 */
export const CONSOLE_API_URL =
  trimUrl(runtime.CONSOLE_API_URL) ||
  trimUrl(process.env.REACT_APP_CONSOLE_API_URL) ||
  "";
